import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
import ReadAxios from '../axiosComponent/read';
const MyServiceProvider = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        ReadAxios({ url: 'networkProviderMaster' }).then((response) => {
            response?.data?.resultSet?.length && setcontent(response?.data?.resultSet)
            // console.log(response)
            setloading(false)
        })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.networkProviderCode
            temp.text = object.networkProviderName
            temp.value = object.networkProviderMasterId
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyServiceProvider